import { all, takeEvery, put, call } from 'redux-saga/effects'
import topicsApi from 'services/topics'
import { actions } from './actions'

export function* loadTopicsProgress(ids) {
  try {
    const response = yield call(topicsApi.loadTopicsProgress, ids.payload)

    yield put({
      type: actions.LOAD_TOPICPROGRESS_RESULT,
      payload: response,
    })
  } catch (error) {
    yield put({
      type: actions.LOAD_TOPICPROGRESS_RESULT,
      error,
    })
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_TOPICPROGRESS_REQUEST, loadTopicsProgress)])
}
